import React from 'react';
import { CheckIcon } from 'lucide-react';
import { ImageSlot } from './ImageSlot';
import { included, includedFacts, needs, productImages } from '../data/content';
export function WhatsIncluded() {
  return <section id="incluye" className="bg-night" data-id="element-199" data-mp="3uaf6ihb9eefj">
      
    </section>;
}